import React, { useState } from 'react'
const { runPreflight } = require('twilio-video')

function useConnectivityTest() {
  const [connectivityReport, setConnectivityReport] = useState(null)
  const testConnectivity = token => {
    return new Promise(async (resolve, reject) => {
      const preflightTest = runPreflight(token)
      preflightTest.on('progress', progress => {
        console.log('preflight progress:', progress)
      })

      // if the test failed, the failed event fires and returns the error
      // along with the partial test results it was able to collect
      preflightTest.on('failed', (error, report) => {
        console.error('preflight error:', error)
        console.log('Received partial report:', report)
        setConnectivityReport(report)
        // reject(error)
      })

      // if the test completed without error, the completed event fires
      // and returns the preflight test report
      preflightTest.on('completed', report => {
        console.log(
          'Test completed in ' + report.testTiming.duration + ' milliseconds.'
        )
        console.log(
          ' It took ' +
            report.networkTiming.connect?.duration +
            ' milliseconds to connect'
        )
        console.log(
          ' It took ' +
            report.networkTiming.media?.duration +
            ' milliseconds to receive media'
        )
        setConnectivityReport(report)
        resolve(report)
      })
    })
  }
  return {
    connectivityReport,
    setConnectivityReport,
    testConnectivity,
  }
}

export default useConnectivityTest
